<script context="module">

    export const HS_API_URL = 'https://prod.api.aemtler-bon.ch';


    export const register = async (data) => {

        return fetch(window.apiUrl + '/register', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'registerKey': 'jT77DmJpIBnq_Q23MkHp0uU66mJscIXKeFadzsIYQnY'
            },

            body: JSON.stringify(data)

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };



</script>
